export default "__VITE_ASSET__DevmFcR5__"